module.exports = {
    NONE: 'None',
    CREDITCARD: 'CreditCard',
    PAYPAL: 'PayPal',
    ACCOUNT: 'Account',
};



// WEBPACK FOOTER //
// ./src/digitalpay/digital-pay-single-select-type.constants.js